import React, { useEffect, useMemo, useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { Context } from '../../config';
import { careersSelector } from 'store/ducks/careers/selectors/careerSelector';
import { Status } from '../../store/ducks/careers/types';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getCareers } from '../../store/ducks/careers/actions';
import { CareersAnimation } from '../../components/animations';

const Home = () => {
    const { siteDomain, locale } = useContext(Context);
    const startText = useRef();
    const dispatch = useDispatch();
    const careers = useSelector(careersSelector);
    const { status } = useSelector(
        (state: {
            careersReducer: {
                status: Status;
            };
        }) => state.careersReducer
    );

    useEffect(() => {
        if (status === 'IDLE') {
            dispatch(getCareers(locale));
        }
    }, []);

    useEffect(() => {
        if (status === 'SUCCESS') {
            setTimeout(() => {
                startText.current.classList.add('_active');
            }, 100);
        }
    }, [status]);

    return (
        <>
            <Helmet>
                <title>{careers.title}</title>
                <meta property="og:title" content={`${careers.title}`} />
                <meta property="twitter:title" content={`${careers.title}`} />
                <meta name="description" content={`${careers.description}`} />
                <meta
                    property="og:description"
                    content={`${careers.description}`}
                />
                <meta
                    property="twitter:description"
                    content={`${careers.description}`}
                />
                <meta
                    property="og:image"
                    content={`${siteDomain}/img/overbest_og_en.png`}
                />
                <meta property="og:url" content={`${siteDomain}/careers`} />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <main className="page-careers">
                <CareersAnimation />
                {status === 'SUCCESS' && (
                    <>
                        <section className="first-screen page-careers__first-screen">
                            <div
                                className="first-screen__container"
                                ref={startText}
                            >
                                <h1 className="first-screen__title title title--black">
                                    {careers.title}
                                </h1>
                                <p
                                    style={{ whiteSpace: 'pre-line' }}
                                    className="first-screen__text text text--black"
                                    dangerouslySetInnerHTML={{
                                        __html: careers.description,
                                    }}
                                ></p>
                            </div>
                        </section>
                        {careers.jobOpeningsList &&
                            careers.jobOpeningsList.length > 0 && (
                                <section className="job page-careers__job">
                                    <div className="job__container">
                                        {careers.jobOpeningsTitle && (
                                            <h2 className="job__title title title--black">
                                                {careers.jobOpeningsTitle}
                                            </h2>
                                        )}
                                        <ul className="positions-list job__list">
                                            {careers.jobOpeningsList.map(
                                                (item: any) => (
                                                    <li
                                                        className="positions-list__item"
                                                        key={item.id}
                                                    >
                                                        <a href={item.LinkUrl}>
                                                            <h3 className="positions-list__name smallTitle smallTitle--black">
                                                                {item.Title}
                                                            </h3>
                                                            <span className="positions-list__location smallTitle">
                                                                {item.Location}
                                                            </span>
                                                            <span className="positions-list__btn button button--white button--medium">
                                                                {
                                                                    item.LinkCaption
                                                                }
                                                            </span>
                                                        </a>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </section>
                            )}
                        {careers.bottomInfo && (
                            <section className="join page-careers__join">
                                <div className="join__container">
                                    <h2
                                        className="join__title title title--black"
                                        dangerouslySetInnerHTML={{
                                            __html: careers.bottomInfo.Title,
                                        }}
                                    />
                                    <p
                                        className="join__text text text--black"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                careers.bottomInfo.Description,
                                        }}
                                    />
                                    <a
                                        href={careers.bottomInfo.LinkUrl}
                                        className="join__btn button button--white"
                                    >
                                        {careers.bottomInfo.LinkCaption}
                                    </a>
                                </div>
                            </section>
                        )}
                    </>
                )}
            </main>
        </>
    );
};

export default Home;
